import { keepPreviousData, useInfiniteQuery } from "@tanstack/react-query";
import { variableApi } from "../services/api";
import { VariableFilters, VariableListResponse } from "../types/variable";

export const useVariablesInfinite = (
  filters: Omit<VariableFilters, "page"> = {},
) => {
  return useInfiniteQuery({
    queryKey: ["variables-infinite", filters],
    queryFn: ({ pageParam }) =>
      variableApi.getVariables({ ...filters, page: pageParam, page_size: 20 }),
    initialPageParam: 1,
    getNextPageParam: (lastPage: VariableListResponse) => {
      if (lastPage.page < lastPage.total_pages) {
        return lastPage.page + 1;
      }
      return undefined;
    },
    placeholderData: keepPreviousData,
    staleTime: 5 * 60 * 1000,
  });
};
